import React from 'react';
import { Handle, Position } from 'reactflow';
import './TriggerNode.css';

const TriggerNode = ({ data, isConnectable }) => {
    const triggerTypes = {
        purchase_completed: { icon: '🛒', color: '#10b981' },
        form_submitted: { icon: '🎁', color: '#667eea' },
        access_granted: { icon: '🔓', color: '#f59e0b' },
        ticket_purchased: { icon: '🎫', color: '#8b5cf6' }
    };

    const triggerInfo = triggerTypes[data.triggerType] || triggerTypes.purchase_completed;

    return (
        <div className="sales-trigger-node" style={{ '--node-color': triggerInfo.color }}>
            <div className="sales-node-header trigger">
                <span className="sales-node-icon">{triggerInfo.icon}</span>
                <span className="sales-node-title">TRIGGER</span>
            </div>
            
            <div className="sales-node-content">
                <h4>{data.label}</h4>
                <p className="sales-node-description">
                    {data.triggerType === 'purchase_completed' && 'Fires when customer completes Stripe payment'}
                    {data.triggerType === 'form_submitted' && 'Fires when customer submits form for free product'}
                    {data.triggerType === 'access_granted' && 'Fires when admin manually grants access'}
                    {data.triggerType === 'ticket_purchased' && 'Fires when customer purchases any event ticket'}
                </p>
                
                {data.config?.reason && (
                    <div className="sales-trigger-reason">
                        💡 {data.config.reason}
                    </div>
                )}
            </div>

            <Handle
                type="source"
                position={Position.Right}
                id="trigger-output"
                isConnectable={isConnectable}
                className="sales-handle sales-handle-output"
            />
        </div>
    );
};

export default TriggerNode;
